module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xy-realName-confirm"
  }, [_c('x-dialog', {
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    staticClass: "confirm-container"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("确认实名信息")]), _vm._v(" "), _c('span', {
    staticClass: "notice"
  }, [_vm._v("该信息一经提交无法修改,请再次确认!")]), _vm._v(" "), _c('div', {
    staticClass: "content-container"
  }, [_c('div', [_c('span', [_vm._v("姓名:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("身份证号:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.idCard))])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-container"
  }, [_c('button', {
    on: {
      "click": _vm.modifyBtnClick
    }
  }, [_vm._v("修改")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.sureBtnClick
    }
  }, [_vm._v("确定提交")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0184b98a!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/common/xy-realName-confirm.vue
// module id = 385
// module chunks = 36